import React from 'react';
import { useSelector } from 'react-redux';
import { navigate as _navigate } from '@reach/router';
import { basepathSelector } from 'src/redux/app/selectors';

export const useNavigate = () => {
  let basepath = useSelector(basepathSelector);

  if (basepath[basepath.length - 1] === '/') {
    basepath = basepath.substr(0, basepath.length - 1);
  }

  return (to, ...args) => _navigate(basepath + to, ...args);
};
